export default __webpack_public_path__ + "static/media/portfolio-6.c6b9e190.jpg";